import { useEffect, useState } from "react";
// import Star from "../Helpers/icons/Star";
import { baseUrl } from "../../config/axios";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/slices/userDataSlice";
import { ErrorToaster, SuccessToaster } from "../Helpers/toaster/Toaster";
import { StarBorder, Star } from "@mui/icons-material";
import SelectStoreModal from "../Helpers/Modal/SelectStoreModal";
import { useAuth } from "../../context/UseContext";
import { currency, DropShipperTypeId, getDate, getLoginUrl } from "../../utils";
import { Rating } from '@mui/material';
import { useLocation, useNavigate } from "react-router-dom";

export default function ProductView({ className, reportHandler, data, categoryName, subCategoryName }) {

  const { user, hasConnectedStore } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();
  const { cart } = useSelector(state => state.userDataReducer)
  const [src, setSrc] = useState();

  const [variationTypes, setVariationTypes] = useState(null);

  const [parentVariations, setParentVariations] = useState([]);
  const [childVariations, setChildVariations] = useState([]);
  const [selectedParentVariant, setSelectedParentVariant] = useState('');
  const [selectedChildVariant, setSelectedChildVariant] = useState('');
  const [availableStock, setAvailableStock] = useState(0);
  const [isStockAvailable, setIsStockAvailable] = useState(true);
  const [selectedPrice, setSelectedPrice] = useState(null);
  const [selectedVariantImages, setSelectedVariantImages] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);

  // *Description ko chota dikhane ke liye (See more / See less)
  const [showFullDesc, setShowFullDesc] = useState(false);

  // *Variant (color/size) tag ka common style
  const variantTagStyle = (active, outOfStock) => ({
    borderColor: active ? '#009640' : '#EFEFEF',
    backgroundColor: active ? '#009640' : '#FFFFFF',
    color: active ? '#FFFFFF' : (outOfStock ? '#BDBDBD' : '#222222'),
    textDecoration: outOfStock ? 'line-through' : 'none',
    fontWeight: active ? 600 : 500,
    opacity: outOfStock && !active ? 0.65 : 1,
  });

  const changeImgHandler = (current) => {
    setSrc(current);
  };
  const [quantity, setQuantity] = useState(1);
  const [minQuantity, setMinQuantity] = useState(1);

  const handleAddTotCart = (item) => {
    if (user?.token) {
      if (!user?.iswhatsappverified) {
        ErrorToaster('You have not verified your whatsapp number. Please verify your whatsapp number.')
        return
      }
      if (selectedParentVariant === '') {
        ErrorToaster('Please select variant')
        return
      }
      if (selectedChildVariant === '') {
        ErrorToaster('Please select variant')
        return
      }
      dispatch(addToCart({
        ...item,
        min_quantity: minQuantity,
        quantity: quantity,
        variantPrice: selectedChildVariant?.discountedPrice > 0 ? selectedChildVariant.discountedPrice : selectedPrice,
        variantImage: selectedVariantImages[0] || null,
        parentVariant: { id: selectedParentVariant?.id, name: selectedParentVariant?.name, type: variationTypes?.parent?.name },
        childVariant: { ...selectedChildVariant, type: variationTypes?.child?.name }
      }))
      SuccessToaster('Product Add Successfully')
    } else {
      ErrorToaster('Kindly login first')
      // *Login ke baad wapas isi product page par aane ke liye
      navigate(getLoginUrl(), { state: { from: `${location.pathname}${location.search}` } })
    }
  };

  const decrement = (item) => {
    // setQuantity((prev) => prev - 1);
    SuccessToaster('Product Remove Successfully')
  };

  // *For Handle Child Variation
  const handleSetChildVariation = (child) => {
    try {
      // const array = []
      // child.forEach(element => {
      //   let obj = {
      //     id: element?.variation_type_id,
      //     value: element?.variation_type_name,
      //     productVariationId: element?.product_variation_id,
      //   }
      //   array.push(obj);
      // });
      setChildVariations(child)

      setSelectedChildVariant(child[0])
      handleStock(child[0])
    } catch (error) {
      console.log('file: ProductView.jsx:75 => handleSetChildVariation => error:', error)
    }
  }

  const handleStock = (data) => {
    try {
      setAvailableStock(data?.stock)
      setIsStockAvailable(data?.stock > 0)
      setSelectedPrice(data?.price ?? null)
      const imgs = data?.images || []
      setSelectedVariantImages(imgs)
      if (imgs.length > 0) {
        setSrc(baseUrl + imgs[0].imagePath + imgs[0].image)
      }
    } catch (error) {
      console.log('file: ProductView.jsx:75 => handleStock => error:', error)
    }
  }

  useEffect(() => {
    if (data) {
      setShowFullDesc(false)
      const storeQty = cart.find(item => item.id === data?.id)?.quantity
      setQuantity(storeQty ? storeQty : 0)
      setSrc(data?.images?.[0] ? baseUrl + data.images[0].imagePath + data.images[0].image : `${process.env.PUBLIC_URL}/assets/images/placeholder.png`)

      setVariationTypes({
        parent: {
          id: data?.variations[0]?.parent_variation.type_id,
          name: data?.variations[0]?.parent_variation.type_name
        },
        child: {
          id: data?.variations[0]?.child_variation[0].type_id,
          name: data?.variations[0]?.child_variation[0].type_name
        }
      })

      const variations = data?.variations.reduce((acc, item) => {
        const { parent_variation, child_variation } = item;

        let existingParent = acc.find(p => p.id === parent_variation.variation_type_id);

        if (existingParent) {
          child_variation?.forEach(newChild => {
            const isChildDuplicate = existingParent.childVariation.some(
              c => c.id === newChild.variation_type_id
            );

            if (!isChildDuplicate) {
              existingParent.childVariation.push({
                id: newChild.variation_type_id,
                name: newChild.variation_type_name,
                stock: newChild.stock,
                product_variation_id: newChild.product_variation_id,
                price: newChild.price,
                discountedPrice: newChild.discounted_price,
                images: newChild.images || [],
                sku: newChild.sku || '',
              });
            }
          });
        } else {
          acc.push({
            id: parent_variation.variation_type_id,
            name: parent_variation.variation_type_name,
            childVariation: (child_variation || []).map(c => ({
              id: c.variation_type_id,
              name: c.variation_type_name,
              stock: c.stock,
              product_variation_id: c.product_variation_id,
              price: c.price,
              discountedPrice: c.discounted_price,
              images: c.images || [],
              sku: c.sku || '',
            }))
          });
        }
        return acc;
      }, []);

      setParentVariations(variations)

      if (variations.length > 0) {
        setSelectedParentVariant(variations[0])
        handleSetChildVariation(variations[0]?.childVariation)
      }

      if (data?.min_quantity) {
        if (DropShipperTypeId == user?.type) {
          setQuantity(data?.min_quantity)
          setMinQuantity(data?.min_quantity)
        } else {
          setQuantity(data?.min_quantity)
          setMinQuantity(data?.min_quantity)
          // setQuantity(data?.min_quantity > 1 ? data?.min_quantity : 2)
          // setMinQuantity(data?.min_quantity > 1 ? data?.min_quantity : 2)
        }
      }
    }
  }, [data]);

  return (
    <div
      className={`product-view w-full lg:flex justify-between ${className || ""
        }`}
    >

      <SelectStoreModal open={openDialog} close={() => setOpenDialog(false)} productId={data?.id} />

      <div data-aos="fade-right" className="lg:w-1/2 xl:mr-[70px] lg:mr-[50px]">
        <div className="w-full">
          <div className="w-full h-[600px] border border-qgray-border flex justify-center items-center overflow-hidden relative mb-3">
            <img
              src={src}
              alt=""
              className="object-contain"
            />
            {/* {(data?.discounted_price || data?.discount_percentage) &&
              <div className="w-[80px] h-[80px] rounded-full bg-qyellow text-white flex justify-center items-center text-xl font-medium absolute left-[30px] top-[30px]">
                <span>
                  -{data?.discounted_price > 0 ? `${currency}${data?.price - data?.discounted_price}` : `${data?.discount_percentage}%`}
                </span>
              </div>
            } */}
          </div>
          <div className="flex gap-2 flex-wrap">
            {(selectedVariantImages.length > 0 ? selectedVariantImages : data?.images || []).map((img, idx) => (
              <div
                onClick={() => changeImgHandler(baseUrl + img?.imagePath + img?.image)}
                key={img.id ?? idx}
                className="w-[110px] h-[110px] p-[15px] border border-qgray-border cursor-pointer"
                style={{ border: '2px solid', borderColor: '#009640' }}
              >
                <img
                  src={baseUrl + img?.imagePath + img?.image}
                  alt=""
                  className={`w-full h-full object-contain `}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="flex-1">
        <div className="product-details w-full mt-10 lg:mt-0">
          <span
            data-aos="fade-up"
            className="text-qyellow  text-xs font-normal uppercase tracking-wider mb-2 inline-block"
            style={{ color: '#009640', fontWeight: '700' }}
          >
            {categoryName}
          </span>
          <p
            data-aos="fade-up"
            className="text-xl font-medium text-qblack mb-4"
          >
            {data?.name}
          </p>

          {data?.average_rating !== '' &&
            <div
              data-aos="fade-up"
              className="flex space-x-[10px] items-center mb-6"
            >
              <div className="flex">
                <Rating name="half-rating-read" defaultValue={data?.average_rating} precision={0.5} readOnly />
              </div>
              <span className="text-[13px] font-normal text-qblack">
                {data?.total_ratings} Reviews
              </span>
            </div>
          }

          <div data-aos="fade-up" className="flex space-x-2 items-center mb-7">
            {selectedPrice != null ? (
              <>
                {selectedChildVariant?.discountedPrice > 0 &&
                  <span className="text-sm font-500 text-qgray line-through mt-2">
                    {currency}{selectedPrice}
                  </span>
                }
                <span className="text-2xl font-500 text-qred">
                  {currency}{selectedChildVariant?.discountedPrice > 0 ? selectedChildVariant.discountedPrice : selectedPrice}
                </span>
              </>
            ) : data?.flash_sale_price > 0 ? (
              <span className="text-2xl font-500 text-qred">
                {currency}{data?.flash_sale_price}
              </span>
            ) : (
              <>
                {(data?.discounted_price || data?.discount_percentage) > 0 &&
                  <span className="text-sm font-500 text-qgray line-through mt-2">
                    {currency}{data?.price}
                  </span>
                }
                <span className="text-2xl font-500 text-qred">
                  {currency}{data?.discounted_price > 0 ? data?.discounted_price : data?.discount_percentage > 0 ? `${data?.price - ((data?.discount_percentage / 100) * data?.price)}` : data?.price}
                </span>
              </>
            )}
          </div>

          <div className="flex items-center gap-2">
            {data?.is_pl == 1 &&
              <div className="product-type mb-4">
                <span
                  className={`text-[12px] font-700 leading-none py-[6px] px-3 uppercase text-white rounded-full tracking-wider bg-qyellow`}
                >
                  Customizable
                </span>
              </div>
            }

            {data?.is_allowed_by_daraz == 1 &&
              <div className="product-type mb-4">
                <span
                  className={`text-[12px] font-700 leading-none py-[6px] px-3 uppercase text-white rounded-full tracking-wider bg-qyellow`}
                >
                  Allow By Daraz
                </span>
              </div>
            }

            {data?.is_self_shipping == 1 &&
              <div className="product-type mb-4">
                <span className="text-[12px] font-700 leading-none py-[6px] px-3 uppercase text-white rounded-full tracking-wider bg-qgray">
                  Self Shipping
                </span>
              </div>
            }
          </div>

          {(data?.description && data?.description !== 'undefined' && data?.description !== 'null') &&
            <div data-aos="fade-up" className="mb-[25px]">
              <p
                className="text-qgray text-sm text-normal leading-7"
                style={(!showFullDesc && (data?.description || '').length > 220) ? {
                  display: '-webkit-box',
                  WebkitLineClamp: 4,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                } : undefined}
              >
                {data?.description}
              </p>
              {(data?.description || '').length > 220 &&
                <button
                  type="button"
                  onClick={() => setShowFullDesc(!showFullDesc)}
                  className="text-[13px] font-600 mt-1 underline underline-offset-2"
                  style={{ color: '#009640' }}
                >
                  {showFullDesc ? 'See less' : 'See more'}
                </button>
              }
            </div>
          }

          {variationTypes?.parent && parentVariations?.length > 0 &&
            <div data-aos="fade-up" className="mb-[25px]">
              <div className="mb-[10px] flex items-center gap-2 text-sm">
                <span className="text-qgray uppercase tracking-wide">
                  {variationTypes?.parent?.name}
                </span>
                {selectedParentVariant?.name &&
                  <span className="text-qblack font-600">: {selectedParentVariant?.name}</span>
                }
              </div>
              <div className="flex flex-wrap gap-2">
                {parentVariations?.map((item, i) => {
                  const active = selectedParentVariant?.id === item?.id;
                  const outOfStock = item?.childVariation?.length > 0
                    && item?.childVariation?.every(c => !(c?.stock > 0));
                  return (
                    <button
                      key={i}
                      type="button"
                      disabled={outOfStock}
                      onClick={() => {
                        setSelectedParentVariant(item);
                        handleSetChildVariation(item?.childVariation);
                      }}
                      className={`text-[13px] px-4 py-[7px] rounded-full border transition-colors ${outOfStock ? 'cursor-not-allowed' : 'cursor-pointer hover:border-qyellow'}`}
                      style={variantTagStyle(active, outOfStock)}
                    >
                      {item?.name}
                    </button>
                  );
                })}
              </div>
            </div>
          }

          {variationTypes?.child && childVariations?.length > 0 &&
            <div data-aos="fade-up" className="mb-[25px]">
              <div className="mb-[10px] flex items-center gap-2 text-sm">
                <span className="text-qgray uppercase tracking-wide">
                  {variationTypes?.child?.name}
                </span>
                {selectedChildVariant?.name &&
                  <span className="text-qblack font-600">: {selectedChildVariant?.name}</span>
                }
              </div>
              <div className="flex flex-wrap gap-2">
                {childVariations?.map((item, i) => {
                  const active = selectedChildVariant?.id === item?.id;
                  const outOfStock = !(item?.stock > 0);
                  return (
                    <button
                      key={i}
                      type="button"
                      disabled={outOfStock}
                      onClick={() => {
                        setSelectedChildVariant(item);
                        handleStock(item);
                      }}
                      className={`text-[13px] px-4 py-[7px] rounded-full border transition-colors ${outOfStock ? 'cursor-not-allowed' : 'cursor-pointer hover:border-qyellow'}`}
                      style={variantTagStyle(active, outOfStock)}
                    >
                      {item?.name}
                    </button>
                  );
                })}
              </div>
            </div>
          }

          <div
            data-aos="fade-up"
            className="quantity-card-wrapper w-full flex items-center h-[50px] space-x-[10px] mb-[30px]"
          >
            <div className="w-[120px] h-full px-[26px] flex items-center border border-qgray-border">
              <div className="flex justify-between items-center w-full">
                <button
                  disabled={quantity === minQuantity}
                  onClick={() => setQuantity((prev) => prev - 1)}
                  type="button"
                  className="text-base text-qgray"
                >
                  -
                </button>
                <span className="text-qblack">{quantity}</span>
                <button
                  onClick={() => setQuantity((prev) => prev + 1)}
                  type="button"
                  className="text-base text-qgray"
                >
                  +
                </button>
              </div>
            </div>
            {/* <div className="w-[60px] h-full flex justify-center items-center border border-qgray-border">
              <button type="button">
                <span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17 1C14.9 1 13.1 2.1 12 3.7C10.9 2.1 9.1 1 7 1C3.7 1 1 3.7 1 7C1 13 12 22 12 22C12 22 23 13 23 7C23 3.7 20.3 1 17 1Z"
                      stroke="#D5D5D5"
                      strokeWidth="2"
                      strokeMiterlimit="10"
                      strokeLinecap="square"
                    />
                  </svg>
                </span>
              </button>
            </div> */}
            <div className="flex-1 h-full">
              <button
                type="button"
                disabled={!isStockAvailable}
                onClick={() => handleAddTotCart(data)}
                className="red-btn text-sm font-semibold w-full h-full"
              >
                <div className="flex items-center space-x-3">
                  <span>
                    <svg
                      width="14"
                      height="16"
                      viewBox="0 0 14 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="fill-current"
                    >
                      <path d="M12.5664 4.14176C12.4665 3.87701 12.2378 3.85413 11.1135 3.85413H10.1792V3.43576C10.1792 2.78532 10.089 2.33099 9.86993 1.86359C9.47367 1.01704 8.81003 0.425438 7.94986 0.150881C7.53106 0.0201398 6.90607 -0.0354253 6.52592 0.0234083C5.47246 0.193372 4.57364 0.876496 4.11617 1.85052C3.89389 2.32772 3.80368 2.78532 3.80368 3.43576V3.8574H2.8662C1.74187 3.8574 1.51313 3.88028 1.41326 4.15483C1.36172 4.32807 0.878481 8.05093 0.6723 9.65578C0.491891 11.0547 0.324369 12.3752 0.201948 13.3688C-0.0106763 15.0815 -0.00423318 15.1077 0.00220999 15.1371V15.1404C0.0312043 15.2515 0.317925 15.5424 0.404908 15.6274L0.781834 16H13.1785L13.4588 15.7483C13.5844 15.6339 14 15.245 14 15.0521C14 14.9214 12.5922 4.21694 12.5664 4.14176ZM12.982 14.8037C12.9788 14.8266 12.953 14.8952 12.9079 14.9443L12.8435 15.0162H1.13943L0.971907 14.8331L1.63233 9.82901C1.86429 8.04766 2.07047 6.4951 2.19289 5.56684C2.24766 5.16154 2.27343 4.95563 2.28631 4.8543C2.72123 4.85103 4.62196 4.84776 6.98661 4.84776H11.6901L11.6966 4.88372C11.7481 5.1452 12.9594 14.5128 12.982 14.8037ZM4.77338 3.8574V3.48479C4.77338 3.23311 4.80559 2.88664 4.84103 2.72649C5.03111 1.90935 5.67864 1.24584 6.48726 1.03339C6.82553 0.948403 7.37964 0.97782 7.71791 1.10202H7.72113C8.0755 1.22296 8.36545 1.41907 8.63284 1.71978C9.06453 2.19698 9.2095 2.62516 9.2095 3.41615V3.8574H4.77338Z" />
                    </svg>
                  </span>
                  <span>
                    {data?.estimate_end_date && new Date() < new Date(data?.estimate_end_date) ? (
                      'Book Now'
                    ) : (
                      `${isStockAvailable ? 'Add To Cart' : 'Out Of Stock'}`
                    )}
                  </span>
                </div>
              </button>
            </div>
            {user?.type == DropShipperTypeId && user?.is_plan_active == 1 && data?.min_quantity == 1 && hasConnectedStore &&
              <div className="flex-1 h-full">
                <button
                  type="button"
                  onClick={() => setOpenDialog(true)}
                  className="text-sm font-semibold w-full h-full flex justify-center items-center"
                  style={{ backgroundColor: '#000000', color: '#fff' }}
                >
                  <div className="flex items-center space-x-3">
                    <span>
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/hashtag-logo-white.png`}
                        alt="hashtag"
                        className="add-to-list-icon"
                      />
                    </span>
                    <span>
                      Add To List
                    </span>
                  </div>
                </button>
              </div>
            }
          </div>

          {data?.is_self_shipping == 1 &&
            <p className="text-[14px] text-qgray leading-7 mb-1" style={{ color: '#FF9900' }}>
              This product is Non-COD.
            </p>
          }

          {data?.estimate_end_date && new Date() < new Date(data?.estimate_end_date) &&
            <p className="text-[14px] text-qgray leading-7 mb-1" style={{ color: '#FF9900' }}>
              The product is currently unavailable but will be available from <b>{getDate(data?.estimate_start_date)}</b> to <b>{getDate(data?.estimate_end_date)}</b>. For now, you can still book the product.
            </p>
          }

          {data?.is_pl == 1 &&
            <p className="text-[14px] text-qgray leading-7 mb-1" style={{ color: '#FF9900' }}>
              The product will be delivered in 15 to 20 working days.
            </p>
          }

          {minQuantity > 1 &&
            <p className="text-[14px] text-qgray leading-7 mb-1" style={{ color: '#FF2121' }}>
              The minimum order quantity must be at least {minQuantity} items.
            </p>
          }

                    <DropshipperOnly>
            <ProfitCalculator costPrice={selectedPrice || data?.product_price || data?.price} defaultQty={minQuantity || 50} />
          </DropshipperOnly>

<div data-aos="fade-up" className="mb-[20px]">
            {selectedChildVariant?.id &&
              <p className="text-[15px] text-qgray leading-7 mb-[10px]" style={{ color: '#4BB543' }}>
                <span className="text-qblack" style={{ color: '#4BB543' }}>Available Stock :</span> {availableStock} &nbsp;items
              </p>
            }
            {(() => {
              const displaySku = selectedChildVariant?.sku || data?.sku
              const specRows = []
              if (categoryName) specRows.push(['Category', categoryName])
              if (subCategoryName) specRows.push(['Sub Category', subCategoryName])
              if (variationTypes?.parent?.name && selectedParentVariant?.name) specRows.push([variationTypes.parent.name, selectedParentVariant.name])
              if (variationTypes?.child?.name && selectedChildVariant?.name) specRows.push([variationTypes.child.name, selectedChildVariant.name])
              if (displaySku && displaySku !== 'null') specRows.push(['SKU', displaySku])
              if (data?.tags?.length > 0) specRows.push(['Tags', data.tags.map((tag) => tag.tag_name).join(', ')])
              if (data?.height && data?.height !== 'null') specRows.push(['Height', data.height])
              if (data?.width && data?.width !== 'null') specRows.push(['Width', data.width])
              if (data?.length && data?.length !== 'null') specRows.push(['Length', data.length])
              if (data?.weight && data?.weight !== 'null') specRows.push(['Weight', `${data.weight} Kg`])
              if (data?.product_condition && data?.product_condition !== 'null') specRows.push(['Condition', data.product_condition])
              if (data?.is_warranty === 1 && data?.warranty) specRows.push(['Warranty', data.warranty])

              if (specRows.length === 0) return null
              return (
                <div className="border border-qgray-border rounded-[6px] overflow-hidden">
                  <div className="px-4 py-[10px] border-b border-qgray-border flex items-center gap-2" style={{ backgroundColor: '#F8F8F8' }}>
                    <span className="inline-block w-[3px] h-[15px] rounded-full" style={{ backgroundColor: '#009640' }}></span>
                    <span className="text-[15px] font-600 text-qblack">Specifications</span>
                  </div>
                  {/* 1 line me 2 se 3 properties (mobile/tablet 2, bari screen 3) */}
                  <div className="grid grid-cols-2 xl:grid-cols-3 gap-2 p-3">
                    {specRows.map(([label, value], i) => (
                      <div
                        key={i}
                        className="min-w-0 rounded-[6px] px-3 py-[7px]"
                        style={{ backgroundColor: '#F8F8F8', border: '1px solid #F0F0F0' }}
                      >
                        <div className="text-[11px] uppercase tracking-wide text-qgray mb-[2px] truncate">{label}</div>
                        <div className="text-[13px] text-qblack font-600 leading-5 break-words">{value}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )
            })()}
          </div>

          {/* <div
            data-aos="fade-up"
            className="flex space-x-2 items-center mb-[20px]"
          >
            <span>
              <svg
                width="12"
                height="13"
                viewBox="0 0 12 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 0C0.247634 0 0.475436 0 0.729172 0C0.738324 0.160174 0.747477 0.316279 0.757647 0.493233C1.05816 0.392044 1.33885 0.282211 1.62818 0.203395C3.11296 -0.201361 4.51385 0.0366111 5.84202 0.779512C6.47661 1.13494 7.14171 1.39071 7.86987 1.47207C8.88125 1.58496 9.82093 1.35817 10.7098 0.88426C10.9335 0.765274 11.1522 0.636627 11.411 0.491199C11.4161 0.606117 11.4237 0.693577 11.4237 0.780529C11.4242 3.18822 11.4222 5.5954 11.4288 8.00309C11.4293 8.1892 11.3718 8.29089 11.2096 8.38039C9.31956 9.42279 7.4285 9.43499 5.54557 8.37734C4.06231 7.54443 2.55363 7.43307 0.992568 8.13835C0.804428 8.22327 0.737816 8.33005 0.739341 8.53904C0.749003 9.9206 0.744426 11.3027 0.744426 12.6842C0.744426 12.7849 0.744426 12.8851 0.744426 13C0.48764 13 0.254244 13 0 13C0 8.67582 0 4.34961 0 0Z"
                  fill="#EB5757"
                />
              </svg>
            </span>

            <button
              type="button"
              onClick={reportHandler}
              className="text-qred font-semibold text-[13px]"
            >
              Report This Item
            </button>
          </div> */}

          {/* <div
            data-aos="fade-up"
            className="social-share flex  items-center w-full"
          >
            <span className="text-qblack text-[13px] mr-[17px] inline-block">
              Share This
            </span>

            <div className="flex space-x-5 items-center">
              <span>
                <svg
                  width="10"
                  height="16"
                  viewBox="0 0 10 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 16V9H0V6H3V4C3 1.3 4.7 0 7.1 0C8.3 0 9.2 0.1 9.5 0.1V2.9H7.8C6.5 2.9 6.2 3.5 6.2 4.4V6H10L9 9H6.3V16H3Z"
                    fill="#3E75B2"
                  />
                </svg>
              </span>
              <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 0C3.6 0 0 3.6 0 8C0 11.4 2.1 14.3 5.1 15.4C5 14.8 5 13.8 5.1 13.1C5.2 12.5 6 9.1 6 9.1C6 9.1 5.8 8.7 5.8 8C5.8 6.9 6.5 6 7.3 6C8 6 8.3 6.5 8.3 7.1C8.3 7.8 7.9 8.8 7.6 9.8C7.4 10.6 8 11.2 8.8 11.2C10.2 11.2 11.3 9.7 11.3 7.5C11.3 5.6 9.9 4.2 8 4.2C5.7 4.2 4.4 5.9 4.4 7.7C4.4 8.4 4.7 9.1 5 9.5C5 9.7 5 9.8 5 9.9C4.9 10.2 4.8 10.7 4.8 10.8C4.8 10.9 4.7 11 4.5 10.9C3.5 10.4 2.9 9 2.9 7.8C2.9 5.3 4.7 3 8.2 3C11 3 13.1 5 13.1 7.6C13.1 10.4 11.4 12.6 8.9 12.6C8.1 12.6 7.3 12.2 7.1 11.7C7.1 11.7 6.7 13.2 6.6 13.6C6.4 14.3 5.9 15.2 5.6 15.7C6.4 15.9 7.2 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0Z"
                    fill="#E12828"
                  />
                </svg>
              </span>
              <span>
                <svg
                  width="18"
                  height="14"
                  viewBox="0 0 18 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.0722 1.60052C16.432 1.88505 15.7562 2.06289 15.0448 2.16959C15.7562 1.74278 16.3253 1.06701 16.5742 0.248969C15.8985 0.640206 15.1515 0.924742 14.3335 1.10258C13.6933 0.426804 12.7686 0 11.7727 0C9.85206 0 8.28711 1.56495 8.28711 3.48557C8.28711 3.7701 8.32268 4.01907 8.39382 4.26804C5.51289 4.12577 2.9165 2.73866 1.17371 0.604639C0.889175 1.13814 0.71134 1.70722 0.71134 2.34742C0.71134 3.5567 1.31598 4.62371 2.27629 5.26392C1.70722 5.22835 1.17371 5.08608 0.675773 4.83711V4.87268C0.675773 6.5799 1.88505 8.00258 3.48557 8.32268C3.20103 8.39382 2.88093 8.42938 2.56082 8.42938C2.34742 8.42938 2.09845 8.39382 1.88505 8.35825C2.34742 9.74536 3.62784 10.7768 5.15722 10.7768C3.94794 11.7015 2.45412 12.2706 0.818041 12.2706C0.533505 12.2706 0.248969 12.2706 0 12.2351C1.56495 13.2309 3.37887 13.8 5.37062 13.8C11.8082 13.8 15.3294 8.46495 15.3294 3.84124C15.3294 3.69897 15.3294 3.52113 15.3294 3.37887C16.0052 2.9165 16.6098 2.31186 17.0722 1.60052Z"
                    fill="#3FD1FF"
                  />
                </svg>
              </span>
            </div>
          </div> */}

        </div>
      </div>
    </div >
  );
}
import { DropshipperOnly, ProfitCalculator } from "../ProfitCalculator";
